import axios from 'axios'
import store from './store'

import baseURL from './env'
import router from './router'
import { Message } from 'element-ui'
require('es6-promise').polyfill()

const requestCount = new Map();
const errorMessage = new Set();

const instance = axios.create({
  baseURL,
  timeout: -1
})

instance.interceptors.request.use(function (config) {
  // config.headers["authorization"] = store.getters.token;
  if (!requestCount.has(location.pathname)) {
    requestCount.set(location.pathname, 1);
  } else {
    requestCount.set(location.pathname, requestCount.get(location.pathname) + 1);
  }
  config.headers['account'] = store.getters.account
  config.headers['token'] = store.getters.token
  config.headers['lang'] = store.getters.language
  return config
}, function (error) {
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  requestCount.set(location.pathname, requestCount.get(location.pathname) - 1);
  if (response.data.code) {
    if (response.data.code != 200) {
      errorMessage.add(response.data.message)
    }

    if (requestCount.get(location.pathname) == 0 && errorMessage.size > 0) {
      Message.warning(errorMessage.values().next().value)
      errorMessage.clear();
    }

    if (response.data.code === 401) {
      router.push('/login');
    }
  }
  return response
}, function (error) {
  return Promise.reject(error)
})

export default instance



// WEBPACK FOOTER //
// ./src/axios.js